import { ActionReducer } from '@ngrx/store';

import * as fromUi from  './ui';
import * as fromUser from  './user';
import * as fromTrades from  './trades';
import * as fromTrade from  './trade';
import * as fromFeed from  './feed';
import * as fromOrganizations from  './organizations';
import * as fromOrganization from  './organization';
import * as fromMembers from  './members';

export interface State {
  ui: fromUi.UiState.State;
  user: fromUser.UserState.State;
  trades: fromTrades.TradesState.State;
  trade: fromTrade.TradeState.State;
  feed: fromFeed.FeedState.State;
  organizations: fromOrganizations.OrganizationsState.State;
  organization: fromOrganization.OrganizationState.State;
  members: fromMembers.MembersState.State;
}

export function clearState(reducer: ActionReducer<any>): ActionReducer<any>  {
  return function (state, action) {
    if (action.type === fromUser.UserActions.ActionTypes.Logout) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export * from './ui';
export * from './user';
export * from './trades';
export * from './trade';
export * from './feed';
export * from './organizations';
export * from './organization';
export * from './members';


